import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeSectionComponent } from './homeSection.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, ButtonModule, TranslateModule],
  declarations: [HomeSectionComponent],
  exports: [HomeSectionComponent],
})
export class HomeSectionModule {}
